export enum GridOperatorCostType {
  G4_G6_UP_TO_10_M3H_LESS_THAN_500_M3_PER_YEAR = 'G4_G6_UP_TO_10_M3H_LESS_THAN_500_M3_PER_YEAR',

  G4_G6_UP_TO_10_M3H_500_TO_4000_M3_PER_YEAR = 'G4_G6_UP_TO_10_M3H_500_TO_4000_M3_PER_YEAR',

  G4_G6_UP_TO_10_M3H_GREATER_THAN_4000_M3_PER_YEAR = 'G4_G6_UP_TO_10_M3H_GREATER_THAN_4000_M3_PER_YEAR',

  G10_UP_TO_16_M3H = 'G10_UP_TO_16_M3H',

  G16_UP_TO_25_M3H = 'G16_UP_TO_25_M3H',

  G25_UP_TO_40_M3H = 'G25_UP_TO_40_M3H',

  E1x25A_UP_TO_3x25A = 'E1x25A_UP_TO_3x25A',
}
